import { render, staticRenderFns } from "./top_tabs.vue?vue&type=template&id=3997750a&scoped=true&"
import script from "./top_tabs.vue?vue&type=script&lang=js&"
export * from "./top_tabs.vue?vue&type=script&lang=js&"
import style0 from "./top_tabs.vue?vue&type=style&index=0&id=3997750a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997750a",
  null
  
)

export default component.exports